<tds-header>
  <tds-header-title style="border-right: 1px solid var(--tds-header--basic-element-border);">
    <a class="tds-headline-04" [routerLink]="['Home']" style="text-decoration: none;color: white;">RENA</a>
  </tds-header-title>

  <!-- <tds-header-dropdown>
    <span slot="label">ADMIN</span>
    <tds-header-dropdown-list>
      <tds-header-dropdown-list-item>
        <a [routerLink]="['Admin/AcessosUsuarios']">Acessos de Usuários</a>
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown> -->

  <tds-header-dropdown>
    <span slot="label">RENAVAM</span>
    <tds-header-dropdown-list>
      <tds-header-dropdown-list-item>
        <a [routerLink]="['Renavam/Codigos']">Códigos</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a [routerLink]="['Renavam/Notificacao']">Notificações</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a [routerLink]="['Renavam/MarcaModelo']">Classificação de Modelos</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a [routerLink]="['Renavam/SolicitacaoEnvio']">Solicitação de Envio - BIN</a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        <a [routerLink]="['Renavam/RetornoPreCadastro']">Retorno Pré-Cadastro</a>
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown>

  <tds-header-item>
    <a [routerLink]="['Renave']">RENAVE</a>
  </tds-header-item>

  <tds-header-item slot="end" id="username" [attr.imgAlt]="tokenClaims?.userid">
    <ng-container *ngIf="tokenClaims; else login">
      <a style="pointer-events: none;">
        <span>
          {{tokenClaims.name | uppercase}}
          <br/>
          {{tokenClaims.preferred_username}}
        </span>
      </a>
      <button (click)="sair()" title="Efetuar logout da aplicação">
        <tds-icon style="transform: rotate(-90deg);" name="download" size="20px"></tds-icon>
      </button>
    </ng-container>
  </tds-header-item>

  <ng-template #login>
    <button (click)="entrar()" title="Efetuar login na aplicação">
      Login
    </button>
  </ng-template>

  <tds-header-brand-symbol slot="end">
    <a aria-label="Scania - red gryphon on blue shield" href="https://scania.com"></a>
  </tds-header-brand-symbol>
</tds-header>
<tds-spinner *ngIf="loadingState" size="md" variant="standard" class="spinner-overlay"></tds-spinner>
